import { useQuery } from '@hooks/reactQuery';

import { getAvailableGranularityDrillUp } from '@api/kpi';

import { TNameTitle } from '@interfaces/common/common';
import { IAvailableGranularityDrillUpOptionsDTO } from '@interfaces/kpi/dto/kpiDTO';

import { EUserRoles } from '@enums/common';
import { EGranularityValue } from '@enums/kpi-common';

import { refetchOptions } from '@constants/common';
import { AVAILABLE_GRANULARITY_DRILL_UP } from '@constants/queryKeys';

interface IUseQueryAvailableGranularityDrillUpReturned {
	availableGranularityDrillUp?: TNameTitle<EGranularityValue>;
	isLoadingAvailableGranularityDrillUp: boolean;
}

interface IUseQueryAvailableGranularityDrillUp extends IAvailableGranularityDrillUpOptionsDTO {
	isAvailableDrillUp?: boolean;
	isOranVendor: boolean;
}

export const useQueryAvailableGranularityDrillUp =
	(props: IUseQueryAvailableGranularityDrillUp): IUseQueryAvailableGranularityDrillUpReturned => {
		const {
			isAvailableDrillUp = false,
			isOranVendor,
			from,
			to,
			granularity,
			vendor,
		} = props;

		const {
			data: availableGranularityDrillUp,
			isInitialLoading,
			isFetching,
		} = useQuery<TNameTitle<EGranularityValue>>({
			queryKey: [AVAILABLE_GRANULARITY_DRILL_UP],
			queryFn: () => getAvailableGranularityDrillUp({
				from,
				to,
				granularity,
				vendor,
			}),
			allowedRoles: [EUserRoles.networkOperatorKpiUpdater, EUserRoles.networkOperatorKpiViewer],
			enabled: [
				isAvailableDrillUp,
				isOranVendor,
				from,
				to,
				granularity,
				vendor,
			],
			...refetchOptions,
		});

		return {
			availableGranularityDrillUp,
			isLoadingAvailableGranularityDrillUp: isFetching || isInitialLoading,
		};
	};
